import { useEffect } from "react";

import InstantEvents from "shared/util/InstantEvents";

const DEFAULT_OPTIONS = [null, { off: false }];

function useInstantEvents(options = DEFAULT_OPTIONS) {
	useEffect(() => {
		InstantEvents.invoke(...options);
	}, [options]);
}

export default useInstantEvents;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useInstantEvents.js